/** The year a calendar made now is for: this one until August, the next
 * from September, when next year's are printed. */
export const CalendarYear = (now = new Date()): number =>
  now.getUTCFullYear() + (now.getUTCMonth() >= 8 ? 1 : 0)
